export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8443';
export const TOKEN_REFRESH_INTERVAL = 15 * 60 * 1000; // 15 минут
